import { render, staticRenderFns } from "./SocialWidget.vue?vue&type=template&id=6ceab635&"
import script from "./SocialWidget.vue?vue&type=script&lang=js&"
export * from "./SocialWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports